import { jsx } from "react/jsx-runtime";
import InfoIcon from "@mui/icons-material/Info";
import { validateTidalLicense } from "../../base/index.js";
function Info(props) {
  return /* @__PURE__ */ jsx(
    InfoIcon,
    {
      "data-testid": "Info",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Info",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Info.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Info"
};
validateTidalLicense();
export {
  Info
};
//# sourceMappingURL=Info.js.map
